<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cash`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 6a2 2 0 012 2v32a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h38zM7 10v28h34V10H7zm12.774 3.21l4.243 4.242 4.243-4.242a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414L26.126 21H31a1 1 0 011 1v2a1 1 0 01-1 1h-5v2h5a1 1 0 011 1v2a1 1 0 01-1 1h-5v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-5a1 1 0 01-1-1v-2a1 1 0 011-1h5v-2h-5a1 1 0 01-1-1v-2a1 1 0 011-1h4.907l-4.961-4.962a1 1 0 010-1.414l1.414-1.414a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconCash',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
